module.exports = __webpack_public_path__ + "img/mC-big-V1.e8d4803e.png";